import { ListEventEntitiesResponseDataEnum } from '../../../api/v1';

export const Entity = ListEventEntitiesResponseDataEnum;
